let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4V5Gj")).then(() => parcelRequire('6KC4T'));